import { render, staticRenderFns } from "./DocumentApprovalModal.vue?vue&type=template&id=913d9148&scoped=true&"
import script from "./DocumentApprovalModal.vue?vue&type=script&lang=js&"
export * from "./DocumentApprovalModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentApprovalModal.vue?vue&type=style&index=0&id=913d9148&lang=scss&scoped=true&"
import style1 from "./DocumentApprovalModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913d9148",
  null
  
)

export default component.exports